import { useContractDetailsContext } from 'features/ContractDetails/Providers/ContractDetailsContextProvider'
import { UserListItem } from './UserListItemSignatory/UserListItemSignatory'
import Typography from 'components/Typography/Typography'
import './styles.scss'
import { useContractDetailsPopup } from 'features/ContractDetails/Providers/ContractDetailsPopupProvider'
import { Button, BUTTON_TYPES } from 'components/Button'
import { BTN_TXT } from 'constants/txt'
import { SIGNATORY_STATUS_LABELS } from 'features/ContractDetails/constants'
import cn from 'classnames'
import { useCallback } from 'react'
import { TContractDocument } from 'features/ContractDetails/types'

const ContractSignatoryUsers = ({ file }: { file: TContractDocument }) => {
  const contractDetailsContext = useContractDetailsContext()

  const {
    addSignatoryPopup: { actions }
  } = useContractDetailsPopup()

  const { canAddSignatoryToDocument, canReassignSignatory } =
    contractDetailsContext.actions

  const acceptedAvailable = Boolean(
    !file?.is_accepted_automatically && file?.is_redlining_required
  )
  const signedAvailable = Boolean(
    !file?.is_signed_automatically && file?.is_digital_signature_required
  )

  const onOpenSignatoryPopup = useCallback(() => {
    actions.open({ documentId: file.uuid })
  }, [actions, file.uuid])

  return (
    <div className="mt-24 grid">
      {acceptedAvailable && (
        <>
          <div className="text-wrapper flex">
            <Typography.Body2 className="text-wrapper--label">
              Accepted by
            </Typography.Body2>
          </div>
          <div className="users-wrapper">
            {file?.accepted_by &&
              file.accepted_by.map((userInfo) => (
                <UserListItem key={userInfo.uuid} user={userInfo} bigAvatar />
              ))}
          </div>
        </>
      )}
      {signedAvailable && (
        <>
          <div className="text-wrapper flex">
            <Typography.Body2 className="text-wrapper--label">
              Signatory
            </Typography.Body2>
          </div>
          <div className="users-wrapper">
            {file?.signatories &&
              file.signatories.map((signatory) => {
                const statusLabel = SIGNATORY_STATUS_LABELS[signatory.status]
                const reassignAvailable = canReassignSignatory(signatory)

                if (signatory.signatory) {
                  return (
                    <UserListItem
                      key={signatory.uuid}
                      reassignAvailable={reassignAvailable}
                      onReassign={onOpenSignatoryPopup}
                      user={signatory.signatory}
                      statusLabel={statusLabel}
                      bigAvatar
                    />
                  )
                } else if (signatory.email) {
                  return (
                    <UserListItem
                      key={signatory.uuid}
                      reassignAvailable={reassignAvailable}
                      email={signatory.email}
                      onReassign={onOpenSignatoryPopup}
                      statusLabel={statusLabel}
                    />
                  )
                }
              })}
            {canAddSignatoryToDocument(file.uuid) && (
              <Button
                type={BUTTON_TYPES.DEFAULT}
                className={cn('mb-10', {
                  'mt-12': !!file?.signatories?.length
                })}
                small
                onClick={onOpenSignatoryPopup}
                upperCase
              >
                {BTN_TXT.ADD_SIGNATORY}
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default ContractSignatoryUsers
